import {
  Accordion,
  AccordionDetails,
  Divider,
  Grid,
  SelectChangeEvent,
  Typography,
  useEventCallback,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import { memo, useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormTypeDoc } from 'front-office/view-models/type-doc-list';
import TypeRightsList from '../shared/type-rights-list';
import ReleaseModeList from '../shared/release-mode-list';
import GroupTypeDocumentList from '../shared/group-type-document-list';

interface FiltersTypeDocComponentProps {
  filterForm: FormikProps<FiltersFormTypeDoc>;
}

const FiltersTypeDocComponent = ({
  filterForm,
}: FiltersTypeDocComponentProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const onChangeTypeDocumentList = useEventCallback((event: SelectChangeEvent<string>) => {
    filterForm.setFieldValue('typeDoc', event.target.value);
  });

  const onChangeTypeRightsList = useEventCallback((event: SelectChangeEvent<string>) => {
    filterForm.setFieldValue('typeRights', event.target.value);
  });

  const onChangeReleaseModeList = useEventCallback((event: SelectChangeEvent<string>) => {
    filterForm.setFieldValue('mode', event.target.value);
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-groups-content"
        id="panel-groups-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
              <GroupTypeDocumentList
                onChange={onChangeTypeDocumentList}
                value={filterForm.values.typeDoc || ''}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Codice tipo documento"
                label="Codice tipo documento"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterForm.values.code || ''}
                onChange={filterForm.handleChange}
                inputProps={{
                  maxLength: '2',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Descrizione tipo documento"
                label="Descrizione tipo documento"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterForm.values.description || ''}
                onChange={filterForm.handleChange}
                inputProps={{
                  maxLength: '50',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} md={5}>
              <TypeRightsList
                onChange={onChangeTypeRightsList}
                value={filterForm.values.typeRights || ''}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <ReleaseModeList
                onChange={onChangeReleaseModeList}
                value={filterForm.values.mode || ''}
              />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersTypeDocComponent.displayName = 'Filters Type doc component';

const FiltersTypeDoc = memo(FiltersTypeDocComponent);

export default FiltersTypeDoc;
